var exports = {
  "button": "Button.module__button___NHN4Yn",
  "matchSkeletonHeight": "Button.module__matchSkeletonHeight___NHN4Yn",
  "small": "Button.module__small___NHN4Yn",
  "compact": "Button.module__compact___NHN4Yn",
  "superCompact": "Button.module__superCompact___NHN4Yn",
  "fitContent": "Button.module__fitContent___NHN4Yn",
  "fitContainer": "Button.module__fitContainer___NHN4Yn",
  "square": "Button.module__square___NHN4Yn",
  "primary": "Button.module__primary___NHN4Yn",
  "secondary": "Button.module__secondary___NHN4Yn",
  "danger": "Button.module__danger___NHN4Yn",
  "inverted": "Button.module__inverted___NHN4Yn",
  "invertedOutline": "Button.module__invertedOutline___NHN4Yn",
  "ghost": "Button.module__ghost___NHN4Yn",
  "recording": "Button.module__recording___NHN4Yn",
  "buttonRecordingPulse": "Button.module__buttonRecordingPulse___NHN4Yn",
  "spinner": "Button.module__spinner___NHN4Yn",
  "spinnerInner": "Button.module__spinnerInner___NHN4Yn",
  "spinnerItem": "Button.module__spinnerItem___NHN4Yn",
  "spinnerPulsingEllipsis": "Button.module__spinnerPulsingEllipsis___NHN4Yn",
  "iconWrapper": "Button.module__iconWrapper___NHN4Yn",
  "spinnerWrapper": "Button.module__spinnerWrapper___NHN4Yn",
  "hidden": "Button.module__hidden___NHN4Yn",
  "grid": "Button.module__grid___NHN4Yn",
};

__webpack_require__.r(module.exports = exports);
